import { post } from '@rails/request.js';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['option'];
  static values = { url: String, applyAllUrl: String, analyticsLocation: String };
  static outlets = ['boards--shoppable-visibility'];

  // Reflect the board-wide roll-up after a per-product toggle: a master switch is
  // checked only while every product hides that option, unchecked as soon as one shows it.
  syncOptions(boardHidden) {
    const hidden = new Set(boardHidden);
    this.optionTargets.forEach((input) => {
      input.checked = hidden.has(input.value);
    });
  }

  toggleOption({ target }) {
    const option = target.value;
    const hidden = target.checked;

    if (this.hasBoardsShoppableVisibilityOutlet) {
      this.boardsShoppableVisibilityOutlet.setBoardOption(option, hidden);
    }

    this.#persist(this.urlValue, {
      target: option,
      set: hidden,
      location: this.analyticsLocationValue,
    }).then(async (response) => {
      // A redirect means the session ended: the body is the login page, not the JSON total.
      if (!response?.ok || response.redirected) {
        return;
      }

      if (this.hasBoardsShoppableVisibilityOutlet) {
        const data = await response.json;
        this.boardsShoppableVisibilityOutlet.updateTotal(data?.total);
      }
      this.dispatch('shoppables-changed', { prefix: 'boards', target: document });
    });
  }

  // "Apply settings to all project designs" toggle.
  toggleApplyAll({ target }) {
    this.#persist(this.applyAllUrlValue, { set: target.checked });
  }

  // Transient view toggle: reveal the per-product visibility controls on the preview.
  togglePerProductSettings({ target }) {
    if (this.hasBoardsShoppableVisibilityOutlet) {
      this.boardsShoppableVisibilityOutlet.setPerProductSettingsVisible(target.checked);
    }
  }

  #persist(url, body) {
    if (!url) {
      return Promise.resolve();
    }

    return post(url, { body: JSON.stringify(body) });
  }
}
